// extracted by mini-css-extract-plugin
export default {"descriptionPanelContainer":"DescriptionPanel_descriptionPanelContainer__j9W84","descriptionPanel":"DescriptionPanel_descriptionPanel__rrjrl"};